/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CheckboxUncheckedDesigner(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CheckboxUncheckedDesigner',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 14 * scale,
      viewBox: '0 0 14 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('rect', {"stroke":"currentColor","strokeWidth":"2","x":"1","y":"1","width":"12","height":"12","rx":"6","fill":"none"}))
}
